import { ResolveFn, Router } from '@angular/router';
import { ClientsService } from 'libs/core/src/lib/services/clients.service';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { inject } from '@angular/core';

import { IClient } from '@inshuwa-client/models';
import { EMPTY, map } from 'rxjs';

export const clientResolver: ResolveFn<IClient> = () => {
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return EMPTY;
  }

  const { clientId } = decoded;
  return inject(ClientsService)
    .getClientById(clientId)
    .pipe(
      map((user) => {
        localStorage.setItem('client', JSON.stringify(user));
        return user;
      }),
    );
};
